import reducer from "./reducer";
export { default as PerformanceAnalyticsTalent } from "./components/index";
export { default as performanceAnalyticsTalentReducerName } from "./constants";
export default reducer;
